export default __webpack_public_path__ + "static/observian-in-the-cloud-map-fa41e03fd3c80794150257182ca03ea5.png";